import { render, staticRenderFns } from "./formChangeMobile.vue?vue&type=template&id=2a58e6f8&"
import script from "./formChangeMobile.vue?vue&type=script&lang=js&"
export * from "./formChangeMobile.vue?vue&type=script&lang=js&"
import style0 from "./formChangeMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports